import {BenchlingAction} from 'redux-stores/Action';

import {DataPolicy} from './PolicyConstants';
import {PolicyActionType} from './PolicyReduxActions';

export interface PoliciesState {
  // Most subscribers to the store should filter out APPEND via ./getUserFacingPolicies
  // Data policies are set from page bootstrap in the main app, so code only used in the main app can
  // generally assume that the value is non-null.
  dataPolicies?: Array<DataPolicy>;
}

export const POLICIES_INITIAL_STATE: PoliciesState = {
  dataPolicies: undefined,
};

export default function reducePolicies(
  state: PoliciesState = POLICIES_INITIAL_STATE,
  action: BenchlingAction
): PoliciesState {
  switch (action.type) {
    case PolicyActionType.POLICIES_BOOTSTRAPPED: {
      return {
        ...state,
        dataPolicies: action.dataPolicies,
      };
    }
    case PolicyActionType.DATA_POLICY_UPDATED: {
      return {
        ...state,
        dataPolicies: state.dataPolicies!.map((dataPolicy) => {
          if (dataPolicy.id === action.dataPolicy.id) {
            return action.dataPolicy;
          }
          return dataPolicy;
        }),
      };
    }
    default: {
      return state;
    }
  }
}
